import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../hooks/useReduxHook';
import { UserRoleName } from '../../services/identity/types/UserProfile';
import ConsultationPageNewDesign from './ConsultationPageNewDesign';

const ConsultationPageValidation: React.FC = (): any => {
  const user: AuthState = useAppSelector(selectAuth);
  const roleNavigate = useRoleNavigate();
  const { caseId } = useParams();

  const goToDashboard = useCallback(() => roleNavigate('/dashboard'), [roleNavigate]);

  if (
    user.userInfo?.role.name === UserRoleName.CareAdvisor ||
    user.userInfo?.role.name === UserRoleName.Collector ||
    user.userInfo?.role.name === UserRoleName.Provider ||
    user.userInfo?.role.name === UserRoleName.Admin ||
    user.userInfo?.role.name === UserRoleName.SuperAdmin ||
    user.userInfo?.role.name === UserRoleName.OrganizationAdmin
  ) {
    return (
      <div>
        <ConsultationPageNewDesign key={caseId} />
      </div>
    );
  }
  return goToDashboard();
};

export default ConsultationPageValidation;
